import { request, fileUpload } from './request';

export const getAllCustomers = (page = 1, filtersString = '', limit = 50) => {
  return request(`customers?page=${page}${filtersString}&limit=${limit}`);
};

export const getCustomerById = (id) => {
  return request(`customers/${id}`);
};

export const getCustomerHistory = (id) => {
  return request(`customers/${id}/history`);
};
export const getCustomerDocuments = (id) => {
  return request(`customers/${id}/documents`);
};

export const getCustomerReminders = (id) => {
  return request(`customers/${id}/reminders`);
};

export const updateCustomer = (id, body) => {
  return request(
    `customers/${id}`,
    { method: 'PATCH', body },
    'Patient updated successfully!',
  );
};

export const deleteCustomer = (id) => {
  return request(
    `customers/${id}`,
    { method: 'DELETE' },
    'Customer deleted successfully!',
  );
};

export const uploadFiles = ({
  id,
  files,
  type,
  isShared,
  path,
  onUploadProgress,
}) => {
  return fileUpload(`${path}/${id}`, files, type, isShared, onUploadProgress);
};
